var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDrink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "18px",
    viewBox: "0 0 14 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UIKit",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-807.000000, -1161.000000)",
    fill: "#A5BFCE",
    fillRule: "nonzero",
    id: "Group-7"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(530.000000, 750.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M289.375176,411 C289.996177,411 290.500174,411.503997 290.500174,412.124997 C290.500174,412.144429 290.499178,412.175912 290.497977,412.19531 L289.372979,427.945272 C289.336518,428.527443 288.833483,428.999957 288.250179,428.999957 L279.249995,428.999957 C278.666691,428.999957 278.163655,428.527443 278.127195,427.945272 L277.002197,412.19531 C277.000996,412.175912 277,412.144429 277,412.124997 C277,411.503997 277.503997,411 278.124997,411 L289.375176,411 Z M288.770724,412.687496 L278.729072,412.687496 L279.010322,416.624987 L288.489475,416.624987 L288.770724,412.687496 Z M287.726236,427.312461 L288.3689,418.312483 L279.130931,418.312483 L279.773938,427.312461 L287.726236,427.312461 Z",
    id: "drink"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrink);
export default __webpack_public_path__ + "static/media/drink.ac792eca.svg";
export { ForwardRef as ReactComponent };